import { fixedNumber } from '@utils/fixedNumber';

const checkE = fixedNumber(8);

export default checkE;
